
import { Alert, Spinner } from 'reactstrap';
import useApiPrivate from '../../../global/utils/hooks/useApiPrivate';
import { useState, useRef } from 'react';
import useAuth from '../../../global/utils/hooks/useAuth';
import { Toast } from 'primereact/toast';

const RESEND_EMAIL_URL = 'api/v1/user/email/verification-notification';

export default function ResendEmail() {
    const apiPrivate = useApiPrivate();
    const { auth } = useAuth();
    const toast = useRef(null);

    const [isLoading, setIsLoading] = useState(false);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const handleResendEmail = async () => {
        setIsLoading(true);

        try{
            const response = await apiPrivate.post(RESEND_EMAIL_URL);
            setIsLoading(false);
            showSuccess(response.data.status);
        }
        catch (error) {
            setIsLoading(false);
            showError(error?.response?.data?.message);
        }
    }

  return (
    <>
       <Toast ref={toast} position="top-center" />

        <Alert color="warning" className='mb-0'>
            <h5>
                <i className={`bi bi-envelope-at me-1`}></i>
                Verify your email
            </h5>
            <p>
                Check your email for the verification link sent to
                <span className={`fw-bold ms-1`}>
                    {auth?.userInfo?.user?.email}
                </span>
            </p>
            <p className="mb-0">
                Not in inbox or spam folder?
                <span
                    className={`fw-bold ms-1`}
                    style={{cursor:'pointer'}}
                    onClick={handleResendEmail}
                >
                    {
                      isLoading 
                      ? (
                       <>
                          <Spinner size="sm">
                              Loading...
                          </Spinner>
                          <span>
                              {' '}Loading
                          </span>
                       </>
                       )
                        : 'Resend Email'
                    }
                </span>
            </p>
        </Alert>
    </>
  )
}
